import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AnimationService {
    private _animationarray = new Subject<any>();
    private _animationimageindex = new BehaviorSubject(null);
    private _onReinit = new Subject<any>();
    private _onReinitArticle = new Subject<any>();
    private _initEventOnHeader = new Subject<any>();
    private _animateArticle = new BehaviorSubject('');
    constructor() { }

    // Set Image index From Item To Single
    animateImageIndex(index) {
        this._animationimageindex.next(index)
    }
    returnanimationimageindex = this._animationimageindex.asObservable();

    // Return Image index From Single To Item
    animationIndexOnReturn(data) {
        this._animationarray.next(data);
    }

    returnAnimationIndex() {
        return this._animationarray.asObservable();
    }

    animationCalled(slug) {
        this._onReinit.next(slug);
    }

    returnAnimationCalled() {
        return this._onReinit.asObservable();
    }

    initEventOnHeader() {
        this._initEventOnHeader.next();
    }
    returnInitEventOnHeader() {
        return this._initEventOnHeader.asObservable();
    }

    // Article animation on init
    animateArticle(data) {
        this._animateArticle.next(data)
    }
    returnanimateArticle = this._animateArticle.asObservable();

    // Article Animation Back Called 
    animationArticleCalled(slug) {
        this._onReinitArticle.next(slug);
    }

    returnAnimationArticleCalled() {
        return this._onReinitArticle.asObservable();
    }
}
